export const animate = () =>{
    
    // Animation Observers
    const ssFadeInRightElements = document.querySelectorAll(".ssFadeInRight");
    let ssFadeInRightObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
            entry.target.style.animation = "ssFadeInRight .5s ease-in-out 100ms forwards";
            } else {
            entry.target.style.animation = "none";
            }
        });
    });
    ssFadeInRightElements.forEach((element) => {
        ssFadeInRightObserver.observe(element);
    });

    const ssFadeInRightGroup = document.querySelectorAll(".ssFadeInRightGroup>div");
    let ssFadeInRightGroupOb = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                let children = entry.target.children;
                let array = Array.from(children);
                let staggerCount = 80;
                array.forEach(function(item){
                    item.style.animation = "ssFadeInRight .5s ease-in-out " + staggerCount + "ms forwards";
                    staggerCount = staggerCount + 80;
                });
                // entry.target.style.animation = `ssFadeInRight .5s ease-in-out`;
            } else {
                let children = entry.target.children;
                let array = Array.from(children);
                array.forEach(function(item){
                    item.style.animation = "none";
                });
            }
        });
    });
    ssFadeInRightGroup.forEach((element) => {
        ssFadeInRightGroupOb.observe(element);
    });

    const ssFadeInLeftGroup = document.querySelectorAll(".ssFadeInLeftGroup>div");
    let ssFadeInLeftGroupOb = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                let children = entry.target.children;
                let array = Array.from(children);
                let staggerCount = 80;
                array.forEach(function(item){
                    item.style.animation = "ssFadeInLeft .5s ease-in-out " + staggerCount + "ms forwards";
                    staggerCount = staggerCount + 80;
                });
            } else {
                let children = entry.target.children;
                let array = Array.from(children);
                array.forEach(function(item){
                    item.style.animation = "none";
                });
            }
        });
    });
    ssFadeInLeftGroup.forEach((element) => {
        ssFadeInLeftGroupOb.observe(element);
    });


}

